var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 37.4997V54.1663M50.0001 70.833H50.0422M42.8752 16.0798L7.58354 74.9965C6.85591 76.2566 6.4709 77.6852 6.46683 79.1403C6.46276 80.5954 6.83975 82.0262 7.56032 83.2903C8.28088 84.5545 9.3199 85.6079 10.574 86.3458C11.8281 87.0838 13.2535 87.4805 14.7085 87.4965H85.2919C86.7469 87.4805 88.1723 87.0838 89.4264 86.3458C90.6805 85.6079 91.7195 84.5545 92.4401 83.2903C93.1607 82.0262 93.5377 80.5954 93.5336 79.1403C93.5295 77.6852 93.1445 76.2566 92.4169 74.9965L57.1252 16.0798C56.3824 14.8552 55.3365 13.8428 54.0885 13.1401C52.8405 12.4375 51.4324 12.0684 50.0002 12.0684C48.568 12.0684 47.1599 12.4375 45.9119 13.1401C44.6639 13.8428 43.618 14.8552 42.8752 16.0798Z",
    stroke: "url(#paint0_linear_2167_9079)",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2167_9079",
    x1: 6.4668,
    y1: 49.7824,
    x2: 93.5336,
    y2: 49.7824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4D01D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.7aa352374370a48e6ce41107df03fb26.svg";
export { ForwardRef as ReactComponent };